module.exports = __webpack_public_path__ + "static/media/rating.a506274c.svg";